<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="finance" pageId="loan-review" color="white"></help-link>
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y :disabled="!enableForEditRights&&!enableForApproverRights"> 
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(loan_detail.status)" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(loan_detail.status)}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense >
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approve" title="Approve Loan">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||approved_status)" :key="4" @click="reject" title="Reject Loan">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" @click="showEdit" :key="1" title="Edit Loan Payment Details">
                                <v-list-tile-title small>Edit</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" @click="setForReview" :key="2" title="Set to For Review">
                                <v-list-tile-title small>For Review</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>

                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            
            <!-- details -->
            <v-expansion-panel v-if="!loading" v-model="panel" expand style="margin-top:5px;">
                <!-- employee details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-5px;':''">SUMMARY</span>
                        <v-spacer></v-spacer>
                    </template>
                    <loans-summary :loan_detail="loan_detail" :loan_payment_schedule="loan_payment_schedule" :viewedByOwner="false"></loans-summary>
                </v-expansion-panel-content>

                <!-- payment monthly details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-5px;':''">PAYMENT SCHEDULE</span>
                        <v-spacer></v-spacer>
                    </template>
                    <payment-schedule :loan_payment_schedule="loan_payment_schedule"></payment-schedule>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedLoanId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-dialog v-model="dialogLoans" width="700" persistent :fullscreen="isMobile">   
            <add-edit ref="loansRef" :dialogLoans.sync="dialogLoans" @send="getLoanDetail(false)"></add-edit>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedLoanId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'
import loansApi from '@/api/loans'
import commonData from '@/common/data'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'

export default {     
    name: 'Loans',
    metaInfo: {
        title: 'Loan Payments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Loans' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit': () => import('@/components/Loans/AddEditLoans'),
        'loans-summary': () => import('@/components/Loans/LoansDetailsSummary'),
        'payment-schedule': () => import('@/components/Loans/LoanPaymentSchedule'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            common_data: null,
            error: false,
            errorMessage: '',
            loading: false,
            loading_status: false,
            menu_status: false,
            dialogLoans: false,
            panel: [true, true],
            loan_detail: null,
            loan_payment_schedule: []
        }
    },
    methods: {        
        showEdit() {
            this.$refs.loansRef.setUpdate(this.loan_detail, pageKeys.loans)
            this.dialogLoans = true
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    loanId : this.selectedLoanId
                }
                const response = await loansApi.setForReview(data, pageKeys.loans)
                if (response.status == 200) {
                    await this.getLoanDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    loanId : this.selectedLoanId
                }
                const response = await loansApi.approve(data)
                if (response.status == 200) {
                    await this.getLoanDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    loanId : this.selectedLoanId
                }
                const response = await loansApi.reject(data)
                if (response.status == 200) {
                    await this.getLoanDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        async getLoanDetail(show_loading) {
            try {
                this.loading = show_loading
                const response = await loansApi.get(this.selectedLoanId)
                if (response.status == 200) {
                    this.loan_detail = response.data
                    this.loan_payment_schedule = response.data.paymentSchedule
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getLoanDetail(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
        getDeductionModeDesc(deductionMode){
            return this.common_data.deduction_modes.filter(x => {
                return x.deductionMode == deductionMode
            })[0].description
        }
    },
    created() {
        this.commonfn = commonfn
        this.common_data = commonData
        this.numFormat = numFormat

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Loan Payment Details'
        })

        this.getLoanDetail(true)
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasApproverRights
        },
        selectedLoanId() {
            return this.$route.params.loanId
        },
        commentsData() {
            if (this.loan_detail!=null) {
                return {
                    pageQueryId: this.selectedLoanId,
                    pageItemCreatedBy: this.loan_detail.userId,
                    pageLink: this.$router.currentRoute.path.replace('/loans/','/myloans/'), //should send to owner link
                    pageKey: pageKeys.loans,
                    notificationTypeId: notificationTypes.loan_payments
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        isCreatedByLoggedInUser() {
            if (this.loan_detail) return this.loan_detail.createdBy == this.$store.state.userId
        },
        totalComputed() {
            var total = this.loan_payment_schedule.map(x => x.amountDue).reduce((prev,next)=>prev+next)
            return total
        },
        totalPaid() {
            var total = 0.00
            var paidList = this.loan_payment_schedule.filter(x => {
                return x.status == commonfn.getStatusCode('Paid')
            })
            if (paidList.length > 0)
                total = paidList.map(x => x.amountDue).reduce((prev,next)=>prev+next)
            
            return total
        },
        totalPayments() {
            return this.loan_payment_schedule.length
        },
        created_status() {
            if (this.loan_detail!=null) return this.loan_detail.status==commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.loan_detail!=null) return this.loan_detail.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.loan_detail!=null) return this.loan_detail.status==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.loan_detail!=null) return this.loan_detail.status==commonfn.getStatusCode('Rejected')
        },
        cancelled_status() {
            if (this.loan_detail!=null) return this.loan_detail.status==commonfn.getStatusCode('Cancelled')
        },
        enableForApproverRights() {
            return this.hasApproverRights&&(this.forReview_status||this.rejected_status||this.approved_status)
        },
        enableForEditRights() {
            return this.hasEditRights&&(this.created_status||this.rejected_status)
        }
    }
}
</script>